import React from 'react';
import {UncontrolledTooltip} from 'reactstrap';
import Utils, {StandardDateFormatLong} from "./Utils";
import PropTypes from "prop-types";
import moment from 'moment';

const TimeAgo = (props) => {

    return <div style={props.style}>
        <span style={{cursor: "pointer"}} id={props.id}>{props.showRawDate ? `${moment(props.date).format(props.dateFormat)} - ` : '' }{Utils.formatTimeAgo(new Date(props.date)) }</span>
        <UncontrolledTooltip target={props.id} placement={props.tooltipPlacement} fade={false}>{ moment(props.date).format(props.dateFormat) }</UncontrolledTooltip>
    </div>
};

TimeAgo.propTypes = {
    showRawDate: PropTypes.bool,
    dateFormat: PropTypes.string,
    date: PropTypes.any,
    id: PropTypes.string,
    style: PropTypes.object,
    tooltipPlacement: PropTypes.string
};

TimeAgo.defaultProps = {
    tooltipPlacement: "bottom",
    dateFormat: StandardDateFormatLong,
    showRawDate: false
};

export default TimeAgo;


// WEBPACK FOOTER //
// ./src/common/TimeAgo.js